import {
  ArrowPathIcon,
  CalendarDaysIcon,
  CloudArrowUpIcon,
  Cog6ToothIcon,
  FingerPrintIcon,
  LockClosedIcon,
  ServerIcon,
  UserIcon,
} from "@heroicons/react/20/solid";

import image from "../../../assets/landing/hero-sec-img.png";

interface SecondaryFeature {
  name: string;
  description: string;
  icon: React.ComponentType<{ className?: string }>;
}

const secondaryFeatures: SecondaryFeature[] = [
  {
    name: "venAuth Integration",
    description:
      "Easily connect your SSO with venAuth providers like what Google, Facebook, etc does.",
    icon: CloudArrowUpIcon,
  },
  {
    name: "Two-Factor Authentication",
    description:
      "Add an extra layer of security by enabling two-factor authentication for users.",
    icon: LockClosedIcon,
  },
  {
    name: "Scalable Architecture",
    description:
      "Supports scaling to handle millions of users without compromising on performance.",
    icon: ServerIcon,
  },
  {
    name: "Real-Time Analytics",
    description:
      "Get real-time insights into your user authentication and security metrics.",
    icon: CalendarDaysIcon,
  },
  {
    name: "User authentication.",
    description:
      "Securely manage user logins and data access with easy-to-integrate authentication features.",
    icon: UserIcon,
  },
];
export const SecondaryFeatures = () => {
  return (
    <div className="mt-32 sm:mt-56">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl sm:text-center">
          <h2 className="text-base/7 font-semibold text-indigo-400">
            Simple Setup
          </h2>
          <p className="mt-2 text-4xl font-semibold tracking-tight text-pretty text-white sm:text-5xl sm:text-balance">
            No Server? No Problem.
          </p>
          <p className="mt-6 text-lg/8 text-gray-300">
            Everything you need to get started, with no server required. Easily
            integrate and scale without any hassle.
          </p>
        </div>
      </div>
      <div className="relative overflow-hidden pt-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <img
            alt="App screenshot"
            src={image}
            width={2432}
            height={1442}
            className="mb-[-12%] rounded-xl shadow-2xl ring-1 ring-white/10"
          />
          <div aria-hidden="true" className="relative">
            <div className="absolute -inset-x-20 bottom-0 bg-gradient-to-t from-gray-900 pt-[7%]" />
          </div>
        </div>
      </div>
      <div className="mx-auto mt-16 max-w-7xl px-6 sm:mt-20 md:mt-24 lg:px-8">
        <dl className="mx-auto grid max-w-2xl grid-cols-1 gap-x-6 gap-y-10 text-base/7 text-gray-300 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3 lg:gap-x-8 lg:gap-y-16">
          {secondaryFeatures.map((feature) => (
            <div key={feature.name} className="relative pl-9">
              <dt className="inline font-semibold text-white">
                <feature.icon
                  aria-hidden="true"
                  className="absolute top-1 left-1 size-5 text-indigo-500"
                />
                {feature.name}
              </dt>{" "}
              <dd className="inline">{feature.description}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
};
